<template>
    <div class="news" id="news" name="news">
      <div class="top">
        <NavTop activeIndex="2"></NavTop>
      </div>
  
  
  
      <!-- 内容 -->
      <div class="content">
       隐私协议
      </div>
  
    </div>
  </template>
     
  <script>
  import NavTop from '../components/NavTop.vue'
  export default {
    components: {
      NavTop
    },
    data() {
      return {
      
      }
    },
    methods: {
  
  
    }
  }
  
  </script>
  
  <style scoped>
  .content {
    width: 1200px;
    background: #FFFFFF;
    box-shadow: 0px 1px 12px 0px rgba(153, 153, 153, 0.08);
    border-radius: 12px;
  }
  
 
  </style>